import { interpret } from "xstate";
import { UpdateMachine } from "./UpdateMachine";

export const UpdateService = interpret(UpdateMachine);
UpdateService.start();
